import NotFound from 'components/NotFound';
import Databank from 'components/admin/pages/Databank';
import CPTCodes from 'components/admin/pages/Databank/CPTCodes/CPTCodes';
import GrowthData from 'components/admin/pages/Databank/GrowthData/GrowthData';
import ICD10Codes from 'components/admin/pages/Databank/ICD10Codes/ICD10Codes';
import Landmarks from 'components/admin/pages/Databank/Landmarks/Landmarks';
import ModifiersTable from 'components/admin/pages/Databank/Modifiers/ModifiersTable';
import Occupations from 'components/admin/pages/Databank/Occupations/Occupations';
import SpecialtyTable from 'components/admin/pages/Databank/Specialty/SpecialtyTable';
import BaseDatapointPage from 'components/admin/pages/Databank/baseDatapointPage';

const ADMIN_DATABANK = [
  {
    path: 'databank',
    element: <Databank />,
    children: [
      {
        path: ':type',
        element: <BaseDatapointPage />
      },
      {
        path: 'cpt-codes',
        element: <CPTCodes />
      },
      {
        path: 'icd10-codes',
        element: <ICD10Codes />
      },
      {
        path: 'occupations',
        element: <Occupations />
      },
      {
        path: 'growth_data',
        element: <GrowthData />
      },
      {
        path: 'landmarks',
        element: <Landmarks />
      },
      {
        path: 'specialities',
        element: <SpecialtyTable />
      },
      {
        path: 'modifiers',
        element: <ModifiersTable />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];

export default ADMIN_DATABANK;
